
import { useEffect } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ProblemsSection from './components/ProblemsSection';
import SolutionsSection from './components/SolutionsSection';
import FeaturedJobsSection from './components/FeaturedJobsSection';
import StaffVoiceSection from './components/StaffVoiceSection';
import StatsSection from './components/StatsSection';
import StepsSection from './components/StepsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import FloatingLineButton from './components/FloatingLineButton';

const FAQ_ITEMS = [
  {
    question: 'ブランクが5年以上ありますが、大丈夫でしょうか?',
    answer: 'もちろん大丈夫です。当社の登録スタッフの40%がブランクからの復帰です。事前面談や職場見学を通じて、安心して復帰できる職場をご案内いたします。',
  },
  {
    question: '週3日だけでも本当に働けますか?',
    answer: 'はい、可能です。週3日、1日6時間からの勤務も多数ご用意しています。実際に60代の女性の方でも、週3日の出勤で毎月16万円の収入に繋がっています。',
  },
  {
    question: 'LINE での相談はどのくらいで返信がありますか?',
    answer: '平日9:00-18:00の間でしたら、通常1時間以内にお返事いたします。土日祝日も営業しておりますので、お気軽にお問合せください。',
  },
  {
    question: '登録や相談に費用はかかりますか?',
    answer: '一切かかりません。登録、相談、職場紹介まですべて無料です。無理な営業や、ご連絡も一切しませんのでご安心してご利用ください。',
  },
  {
    question: '派遣で働くのが初めてです。どんな仕組みですか?',
    answer: '派遣の仕組みは、派遣元(トラスト)が雇用主となり、派遣先(施設)にあなたを派遣します。給与や福利厚生は派遣元が担当し、派遣先では施設の指示を受ける形です。',
  },
];

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://kaigo.trust-job.com';

  useEffect(() => {
    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'LocalBusiness',
        '@id': `${siteUrl}/#organization`,
        name: '介護派遣トラスト',
        url: siteUrl,
        telephone: '052-887-6243',
        address: {
          '@type': 'PostalAddress',
          addressLocality: '名古屋市',
          addressRegion: '愛知県',
          addressCountry: 'JP',
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: 35.1815,
          longitude: 136.9066,
        },
        description: '名古屋で介護派遣の仕事を探すならトラスト。週3日・1日6時間から働ける介護派遣求人を多数掲載。ブランクがあっても安心のサポート体制。',
        openingHoursSpecification: [
          {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
            opens: '09:00',
            closes: '18:00',
          },
        ],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        '@id': `${siteUrl}/#website`,
        url: siteUrl,
        name: '介護派遣トラスト',
        inLanguage: 'ja',
        publisher: { '@id': `${siteUrl}/#organization` },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: FAQ_ITEMS.map((faq) => ({
          '@type': 'Question',
          name: faq.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.answer,
          },
        })),
      },
    ];

    const existingScripts = document.querySelectorAll('script[data-schema="home"]');
    existingScripts.forEach((s) => s.remove());

    schemas.forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.dataset.schema = 'home';
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    return () => {
      document.querySelectorAll('script[data-schema="home"]').forEach((s) => s.remove());
    };
  }, [siteUrl]);

  return (
    <div className="bg-gray-50">
      <Header />
      <HeroSection />
      <FeaturedJobsSection />
      <StaffVoiceSection />
      <ProblemsSection />
      <SolutionsSection />
      <StatsSection />
      <StepsSection />
      <FAQSection />
      <CTASection />
      <Footer />
      <FloatingLineButton />
    </div>
  );
}